import lazySizes from "lazysizes";

document.addEventListener('lazybeforeunveil', (event) => {
	if (event.detail.instance !== lazySizes) return;
	if (!event.target.hasAttribute('data-module')) return;
	const dependencies = event.target.dataset.dependencies;
	if (!dependencies) {
		event.target.dataset.module = 'ready';
		document.dispatchEvent(new Event('dependency-chain:loaded'));
		return;
	}

	const groups = dependencies.split('|').map(g => g.split(','));
	const loadGroups = async () => {
		for (const group of groups) {
			await Promise.all(group.map(loadScript))
		}
	}
	loadGroups().finally(() => {
		event.target.dataset.module = 'ready';
		document.dispatchEvent(new Event('dependency-chain:loaded'));
	});
});

window.loadScript = function (id) {
	window.dependencies.state[id] = window.dependencies.state[id] ||
		new Promise((resolve, reject) => {
			const script = document.createElement('script');
			script.src = window.dependencies.libraries[id];
			script.onerror = reject;
			script.onload = resolve;
			document.body.appendChild(script);
		})
	.catch(() => console.error(`Could not load dependency: ${id}`));
	return window.dependencies.state[id];
}
